export const DIFF_SEVERITY = {
    MAJOR: 'MAJOR',
    MINOR: 'MINOR',
} as const;

export const DIFF_TYPE = {
    ADDED: 'ADDED',
    REMOVED: 'REMOVED',
    CHANGED: 'CHANGED',
} as const;
